module.exports = __webpack_public_path__ + "static/media/covid.3228d8f1.PNG";